// external imports
import React from 'react'
import { FlexColumn, Text } from 'quark-web'
import { createFragmentContainer, graphql } from 'react-relay'
// local imports
import styles from './styles'
import Empty from './Empty'
import ProductSummaryContent from './ProductSummaryContent'

const ProductSummary = ({ product }) => (
    <FlexColumn grow={1} style={styles.container}>
        {!product ? <Empty /> : <ProductSummaryContent product={product} />}
    </FlexColumn>
)

export default createFragmentContainer(
    ProductSummary,
    graphql`
        fragment ProductSummary_product on Product {
            ...ProductSummaryContent_product
        }
    `
)



// WEBPACK FOOTER //
// ./src/views/Products/ProductSummary/index.js